import CompaniesIndustry from "./NewsStock/CompaniesIndustry";
import ListNew from "./NewsStock/ListNew";

export default function NewsStock () {
  return (
    <>
    <CompaniesIndustry />
    <ListNew />
    </>
  )
}